import { claimApi } from "app/modules/claim/api/claim-api";
import { modifyClaim } from "app/modules/claim/service/claim-service";
import { hideSpinner, showSpinner } from "app/modules/cms/service/store/cms-dispatchs";
import { addGlobalData, removeGlobalData, setStepEngineCreatedBenefit, setStepEngineSubscriber, setUseCases } from "app/modules/step-engine/service/store/step-engine-dispatchs";
import { OrderCode, OrderLabel } from "app/shared/constants/order-code";
import { OrderDTO } from "app/shared/model/OrderDTO.model";
import { ContactBonTransportDTO } from "app/shared/model/contactBonTransportDTO.model";
import { benefitApi } from "../api/benefit-api";
import { setOrder } from "./store/order-dispatch";
import { setSubscriber } from "app/shared/reducers/kubrick-management";
import { get } from "lodash";

export const generateParams = (subscriberSherpa) => {
    const orderDTO: OrderDTO = {
        request: {
            customerId: subscriberSherpa?.subscriberId,
            eventType: {
                code: OrderCode.NEW_REQUEST,
            },
            orderLabel: OrderLabel.NEW_CUSTOMER_ORDER,
            currentProcessingChannel: {
                code: "DIRECT"
            },
        }
    }
    return orderDTO;
}

export const createOrder = (subscriberSherpa) => async dispatch => {
    const params = generateParams(subscriberSherpa);
    try {
        const response = await benefitApi.createOrder(params);
        if (response.status === 200 || response.status === 201) {
            await dispatch(setOrder(response?.data?.response));
            return response;
        }
        else {
            throw new Error('Creating Order Error');
        }
    }
    catch (error) {
        throw new Error('Creating Order Error');
    }
};

export const getBenefit = (params) => async dispatch => {
    try {
        const response = await benefitApi.getBenefit(params);

        if (response.status === 200 || response.status === 201) {
            await dispatch(addGlobalData('benefit', response?.data));
            return response;
        }
        else {
            throw new Error('get Benefit Error');
        }
    }
    catch (error) {
        throw new Error('get Benefit Error');
    }
};

export const createBenefit = (params, orderId) => async dispatch => {
    try {
        const response = await benefitApi.createBenefit(params, orderId);

        if (response.status === 200 || response.status === 201) {
            await dispatch(addGlobalData('benefit', response?.data));
            await dispatch(setStepEngineCreatedBenefit(response?.data?.benefitId));
            return response;
        }
        else {
            throw new Error('Creating Benefit Error');
        }
    }
    catch (error) {
        throw new Error('Creating Benefit Error');
    }
};

export const searchUseCases = (params) => async dispatch => {
    try {
        const response = await benefitApi.searchUseCase(params);

        if (response.status === 200 || response.status === 201) {
            await dispatch(setUseCases(response?.data));
            return response;
        }
        else {
            throw new Error('Search use cases benefit Error');
        }
    }
    catch (error) {
        throw new Error('Search use cases benefit Error');
    }
};

export const updateBenefit = (benefitId, params) => async dispatch => {
    try {
        const response = await benefitApi.updateBenefit(benefitId, params);

        if (response.status === 200 || response.status === 201) {
            await dispatch(addGlobalData('benefit', response?.data));
            return response;
        }
        else {
            throw new Error('Creating Benefit Error');
        }
    }
    catch (error) {
        throw new Error('Creating Benefit Error');
    }
};

export const cancelBenefit = (benefitId) => async dispatch => {
    try {
        const response = await benefitApi.cancelBenefit(benefitId);

        if (response.status === 200 || response.status === 201) {
            await dispatch(removeGlobalData('benefit'));
            return response;
        }
        else {
            throw new Error('Canceling Benefit Error');
        }
    }
    catch (error) {
        throw new Error('Canceling Benefit Error');
    }
};

export const validateBenefit = (benefitId) => async dispatch => {
    try {
        const response = await benefitApi.validateBenefit(benefitId);
    }
    catch (error) {
        throw new Error('Validate Benefit Error : ' + error);
    }
};

export const createBenefitTask = (claimId, params) => async dispatch => {
    try {
        const response = await claimApi.createBenefitTask(claimId, params)
    }
    catch (error) {
        throw new Error('Create Benefit task Error : ' + error);
    }
};

export const getProvideServicePoints = (benefitId, depositMode, zipCode) => async (dispatch,getState): Promise<any> => {
    dispatch(showSpinner());
    const { subscription } = getState().kubrickManagement;
    const{ globalData } = getState().stepEngine;
    const {customerInformation} = globalData;
    

    try {
        if (depositMode === 'PP') {
            await benefitApi.updateBenefitAdresse(benefitId, zipCode);
        }
        const response = await benefitApi.getProvideServicePoints(benefitId, depositMode, zipCode);
        if (depositMode === 'PP') {
            await benefitApi.updateBenefitwhithPrincipalAdresse(benefitId,subscription?.subscriber?.number, customerInformation?.adressePostal);
        }
        if (response.status === 200 || response.status === 201) {
            dispatch(hideSpinner());

            return response?.data;
        }
        else {
            throw new Error('Get Points Service Error');
        }
    }
    catch (error) {
        dispatch(hideSpinner());
        throw new Error('Get Points Service Error');
    }
};

export const getProvideServicePointsByGeographicalCoordinates = (benefitId: string, depositMode: any, latitude: any, longitude: any) => async (dispatch): Promise<any> => {
    try {
        dispatch(showSpinner());
        const response = await benefitApi.getProvideServicePointsByGeographicalCoordinates(benefitId, depositMode, latitude, longitude);
        if (response.status === 200 || response.status === 201) {
            dispatch(hideSpinner());
            return response.data;
        } else {
            dispatch(hideSpinner());
            throw new Error("Erreur lors de la récupération du zipCode");
        }
    } catch (err) {
        dispatch(hideSpinner());
        throw new Error(err);
    }
};

export const generateTransportVoucher = (contactBonTransport: ContactBonTransportDTO, isShowSpinner: boolean) => async (dispatch): Promise<any> => {
    try {
        if (isShowSpinner) {
            dispatch(showSpinner());
        }

        const response = await benefitApi.generateTransportVoucher(contactBonTransport);
        if (response?.status === 200 || response?.status === 201) {
            dispatch(modifyClaim({ trackingNumber: response.data.trackingNumber }));
            if (isShowSpinner) {
                dispatch(hideSpinner());
            }
            return response?.data;
        }
        else if (response?.status === 204) {
            if (isShowSpinner) {
                dispatch(hideSpinner());
            }
            return response?.data;
        }
        else {
            if (isShowSpinner) {
                dispatch(hideSpinner());
            }

            throw new Error("Erreur lors de la generation du bon de Transport");
        }
    } catch (err) {
        dispatch(hideSpinner());
        throw new Error(err);
    }
};

export const createBenefitAddress = (data, benefitId, isShippingAddress) => async dispatch => {
    try {
        const response = await benefitApi.createBenefitAddress(data, benefitId)
        if ((response.status === 200 || response.status === 201) && response.data) {
            // dispatch(setSubscriber(response.data));
            // dispatch(setStepEngineSubscriber(response.data));
            return response;
        } else {
            return false;
        }
    }
    catch (error) {
        throw new Error('Create Benefit Address Error : ' + error);
    }
};
